import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import * as RebelComponents from '@rebeldotcom/ui'
import * as RebelCMSComponents from '../components/features'
import Layout from '../components/layout/layout'
import { SEO } from '../components/seo'
import AccountPage from '../components/account-page'
import './fragments'

const allComponents = {
  ...RebelComponents,
  ...RebelCMSComponents,
}

const propTypes = {
  data: PropTypes.shape({
    pagesJson: PropTypes.shape({
      componentName: PropTypes.string,
      hasLayout: PropTypes.bool,
      seo: PropTypes.shape({
        description: PropTypes.string,
        imageUrl: PropTypes.string,
        title: PropTypes.string,
      }).isRequired,
      slug: PropTypes.string,
      strings: PropTypes.arrayOf(
        PropTypes.shape({ key: PropTypes.string, value: PropTypes.string })
      ),
    }),
  }).isRequired,
}
const FeaturePage = ({ data }) => {
  const {
    seo: pageSEO,
    strings: stringsArray,
    componentName,
    slug,
    hasLayout,
  } = data.pagesJson

  const strings = stringsArray.reduce((acc, obj) => {
    acc[obj.key] = obj.value
    return acc
  }, {})

  const { title, description, imageUrl } = pageSEO

  const Component = allComponents[componentName]

  if (hasLayout === false) {
    return <Component strings={strings} />
  }

  return (
    <Layout location={slug}>
      <SEO
        description={description}
        imageUrl={imageUrl}
        location={slug}
        title={title}
      />
      {slug.includes('my-account') ? (
        <AccountPage component={Component} strings={strings} />
      ) : (
        <Component strings={strings} />
      )}
    </Layout>
  )
}

export const query = graphql`
  query ($slug: String!) {
    pagesJson(slug: { eq: $slug }) {
      slug
      seo {
        title
        description
      }
      componentName
      hasLayout
      strings {
        key
        value
      }
    }
  }
`

FeaturePage.propTypes = propTypes

export default FeaturePage
